module.exports = __webpack_public_path__ + "static/logo-09eadd3bc059543ed1f253a064a0f179.png";